import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b-4 border-orange-400" style={{
      borderStyle: 'dashed'
    }}>
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="w-12 h-12 bg-gradient-to-br from-orange-400 to-red-400 rounded-full flex items-center justify-center shadow-lg" style={{
              border: '3px dashed white'
            }}>
              <i className="ri-restaurant-2-line text-white text-2xl"></i>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-800" style={{ fontFamily: '"Klee One", cursive' }}>
                シルバー料理教室
              </h1>
              <p className="text-xs text-orange-600" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
                楽しく学ぶ、美味しい時間
              </p>
            </div>
          </div>

          <nav className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-orange-600 transition-colors font-medium cursor-pointer"
              style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
            >
              レッスン内容
            </button>
            <button 
              onClick={() => scrollToSection('features')}
              className="text-gray-700 hover:text-orange-600 transition-colors font-medium cursor-pointer"
              style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
            >
              特徴
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className="text-gray-700 hover:text-orange-600 transition-colors font-medium cursor-pointer"
              style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
            >
              ギャラリー
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-orange-400 to-red-400 text-white px-6 py-2.5 rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer font-medium"
              style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
            >
              お問い合わせ
            </button>
          </nav>

          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t-2 border-orange-200" style={{ borderStyle: 'dashed' }}>
            <nav className="flex flex-col gap-4">
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-orange-600 transition-colors font-medium text-left cursor-pointer"
                style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
              >
                レッスン内容
              </button>
              <button 
                onClick={() => scrollToSection('features')}
                className="text-gray-700 hover:text-orange-600 transition-colors font-medium text-left cursor-pointer"
                style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
              >
                特徴
              </button>
              <button 
                onClick={() => scrollToSection('gallery')}
                className="text-gray-700 hover:text-orange-600 transition-colors font-medium text-left cursor-pointer"
                style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
              >
                ギャラリー
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-orange-400 to-red-400 text-white px-6 py-2.5 rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer font-medium text-center"
                style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
              >
                お問い合わせ
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
